import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import CallCard from "./CallCard";
import withRouter from "../../utils/withRouter";


class CallList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            calls: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveCalls();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveCalls();
        }
    }

    async filterCallBack(filters){
        await this.setState({
            filters: filters
        });
        await this.retrieveCalls();
    }

    async retrieveCalls() {
        const url = 'sunsim_call/';
        const api = new BaseApi();
        let params = {
            page_size: 12,
        }
        params = {...params, ...this.state.filters};
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
            response = await api.get(url, params);
        }
        this.setState(
            {
                calls: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.calls) {
            return (<CircularProgress/>)
        }
        return (
            <Stack
                spacing={2}
            >
                <CommonPaginatedComponentList
                    title={'Звонки'}
                    url={'call'}
                    component={CallCard}
                    componentProps={{
                        showPhone: true,
                        showCommunications: true
                    }}
                    componentKeyword={'call'}
                    data={this.state.calls}
                    callBack={this.retrieveCalls.bind(this)}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                />
            </Stack>
        )
    }
}

export default withRouter(CallList)
